import React, { useState } from 'react';
import { api } from '../../api';
import { Save, Check } from 'lucide-react';

const SAVED_FEEDBACK_MS = 2500;

const TextsEditor = ({ content, refresh }) => {
  const [s, setS] = useState(content.settings || {});
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const upd = (lang, section, key, v) => {
    setS((prev) => ({ ...prev, [`${section}${lang}`]: { ...(prev[`${section}${lang}`] || {}), [key]: v } }));
  };

  const save = async () => {
    setSaving(true);
    try {
      await api.put('/admin/settings', {
        heroFr: s.heroFr || {}, heroEn: s.heroEn || {},
        aboutFr: s.aboutFr || {}, aboutEn: s.aboutEn || {},
      });
      await refresh();
      setSaved(true);
      setTimeout(() => setSaved(false), SAVED_FEEDBACK_MS);
    } finally { setSaving(false); }
  };

  const Field = ({ label, value, onChange, textarea }) => (
    <label className="block">
      <span className="text-[10px] tracking-[0.28em] uppercase text-[#8A8275]">{label}</span>
      {textarea ? (
        <textarea value={value || ''} onChange={(e) => onChange(e.target.value)} rows={3}
          className="mt-2 w-full bg-[#FAF8F4] border border-[#E8E2D5] focus:border-[#957340] outline-none p-3 text-[14px] resize-y transition-colors" />
      ) : (
        <input value={value || ''} onChange={(e) => onChange(e.target.value)}
          className="mt-2 w-full bg-[#FAF8F4] border border-[#E8E2D5] focus:border-[#957340] outline-none p-3 text-[14px] transition-colors" />
      )}
    </label>
  );

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="h-display text-[32px]">Textes du site</h2>
          <p className="text-[13px] text-[#8A8275] mt-1">Modifiez les titres et descriptions affichés sur la page d’accueil.</p>
        </div>
        <button onClick={save} disabled={saving} className="btn-primary">
          {saved ? <><Check size={14} /> Enregistré</> : <><Save size={14} /> Enregistrer</>}
        </button>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {[['fr', 'Français'], ['en', 'English']].map(([lang, label]) => (
          <div key={lang} className="space-y-5">
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#957340] border-b border-[#E8E2D5] pb-2">{label}</div>
            <div className="text-[12px] font-medium tracking-wide text-[#1A1A1A]">Hero (haut de page)</div>
            <Field label="Eyebrow" value={s[`hero${lang === 'fr' ? 'Fr' : 'En'}`]?.eyebrow} onChange={(v) => upd(lang === 'fr' ? 'Fr' : 'En', 'hero', 'eyebrow', v)} />
            <Field label="Sous-titre" value={s[`hero${lang === 'fr' ? 'Fr' : 'En'}`]?.subtitle} onChange={(v) => upd(lang === 'fr' ? 'Fr' : 'En', 'hero', 'subtitle', v)} textarea />
            <Field label="Description" value={s[`hero${lang === 'fr' ? 'Fr' : 'En'}`]?.desc} onChange={(v) => upd(lang === 'fr' ? 'Fr' : 'En', 'hero', 'desc', v)} textarea />

            <div className="text-[12px] font-medium tracking-wide text-[#1A1A1A] pt-4">À propos</div>
            <Field label="Titre" value={s[`about${lang === 'fr' ? 'Fr' : 'En'}`]?.title} onChange={(v) => upd(lang === 'fr' ? 'Fr' : 'En', 'about', 'title', v)} />
            <Field label="Paragraphe 1" value={s[`about${lang === 'fr' ? 'Fr' : 'En'}`]?.p1} onChange={(v) => upd(lang === 'fr' ? 'Fr' : 'En', 'about', 'p1', v)} textarea />
            <Field label="Paragraphe 2" value={s[`about${lang === 'fr' ? 'Fr' : 'En'}`]?.p2} onChange={(v) => upd(lang === 'fr' ? 'Fr' : 'En', 'about', 'p2', v)} textarea />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TextsEditor;
